"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = require("prop-types");

var _map = _interopRequireDefault(require("./map"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** Container class name */
  className: _propTypes.string,

  /** color from the color scheme */
  colorScheme: _propTypes.string,

  /** open html content object */
  content: (0, _propTypes.arrayOf)(_propTypes.object),

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** boolean to include styles  */
  includeStyles: _propTypes.bool,

  /** theme object */
  theme: _utils.themePropType
};

var OpenHtmlContent = function OpenHtmlContent(_ref) {
  var content = _ref.content,
      className = _ref.className,
      colorScheme = _ref.colorScheme,
      dataTestId = _ref["data-test-id"],
      includeStyles = _ref.includeStyles,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, content && (0, _utils.mapIndexed)(function (obj, index) {
    return (0, _map["default"])(Object.assign({}, obj, {
      className: className,
      colorScheme: colorScheme,
      "data-test-id": dataTestId,
      includeStyles: includeStyles,
      theme: theme
    }), index);
  }, content));
};

OpenHtmlContent.propTypes = propTypes;
OpenHtmlContent.displayName = "Modules.OpenHtmlContent";

var _default = (0, _styledComponents.withTheme)(OpenHtmlContent);

exports["default"] = _default;